module.exports = __webpack_public_path__ + "img/08.933e5ba7.gif";